module.exports = __webpack_public_path__ + "img/mode_outline_4.380a7c88.png";